<template>
	<v-app>
		<div class="loader" v-if="$myStore.state.loaderCount > 0">
			<v-progress-circular
				:size="50"
				color="primary"
				indeterminate
			></v-progress-circular>
		</div>

		<v-dialog class="dialog-html" max-width="772" v-model="htmlModal.show">
			<v-card>
				<v-card-text v-html="htmlModal.text"> </v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="htmlModal.show = false" color="success">{{
						$t("buttons.ok")
					}}</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog max-width="480" v-model="alertModal.show">
			<v-card>
				<v-card-text
					class="grey--text text--lighten-1"
					v-html="alertModal.text"
				>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="alertModal.show = false">{{
						$t("buttons.ok")
					}}</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog max-width="480" persistent v-model="verifyModal.show">
			<v-card class="pa-4">
				<v-card-text
					class="grey--text text--lighten-1"
					v-html="verifyModal.text"
				>
				</v-card-text>
				<v-card-actions>
					<v-btn
						@click="verifyModal.result(false)"
						color="danger"
						dark
						>{{ $t("buttons.no") }}
					</v-btn>
					<v-spacer></v-spacer>
					<v-btn @click="verifyModal.result(true)">{{
						$t("buttons.yes")
					}}</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog max-width="480" persistent v-model="promptModal.show">
			<v-card class="pa-4">
				<v-card-text class="grey--text text--lighten-1">
					<InputField
						:label="promptModal.text"
						v-model="promptModal.value"
					></InputField>
				</v-card-text>
				<v-card-actions>
					<v-btn
						@click="promptModal.result(false)"
						color="danger"
						dark
						>{{ $t("buttons.cancel") }}
					</v-btn>
					<v-spacer></v-spacer>
					<v-btn @click="promptModal.result(true)">{{
						$t("buttons.ok")
					}}</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog max-width="680" persistent v-model="dropdownModal.show">
			<v-card class="pa-4">
				<v-card-text class="grey--text text--lighten-1">
					<Dropdown
						:ajax="true"
						:data="dropdownModal.endpoint"
						:label="dropdownModal.text"
						v-if="dropdownModal.endpoint != null"
						v-model="dropdownModal.value"
					></Dropdown>
				</v-card-text>
				<v-card-actions>
					<v-btn
						@click="dropdownModal.result(false)"
						color="danger"
						dark
						>{{ $t("buttons.cancel") }}
					</v-btn>
					<v-spacer></v-spacer>
					<v-btn @click="dropdownModal.result(true)">{{
						$t("buttons.ok")
					}}</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog max-width="480" persistent v-model="dateModal.show">
			<v-card class="pa-4">
				<v-card-text class="grey--text text--lighten-1">
					<v-flex xs12 class="black--text title mb-3">
						{{ dateModal.title }}
					</v-flex>
					<DatePicker
						class="no-pa"
						:date-label="dateModal.text"
						v-model="dateModal.value"
					></DatePicker>
				</v-card-text>
				<v-card-actions>
					<v-btn @click="dateModal.result(false)" color="danger" dark
						>{{ $t("buttons.cancel") }}
					</v-btn>
					<v-spacer></v-spacer>
					<v-btn @click="dateModal.result(true)">{{
						$t("buttons.ok")
					}}</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<PersonModal
			:id="0"
			:show="personModalShow"
			@callback="personModalCallback"
		/>
		<CompanyModal
			:id="0"
			:show="companyModalShow"
			@callback="companyModalCallback"
		/>

		<v-snackbar
			:timeout="3000"
			:top="true"
			class="notification text-xs-center"
			color="primary"
			v-model="notification.show"
			>{{ notification.text }}
		</v-snackbar>

		<template v-if="$myStore.state.loggedIn">
			<v-navigation-drawer
				:width="220"
				app
				class="main-menu"
				clipped
				dark
				fixed
				v-model="drawer"
			>
				<v-list dense>
					<v-list-tile :to="{ path: '/tours' }" class="pa-0">
						<v-list-tile-action>
							<v-icon small>fa-map-marked-alt</v-icon>
						</v-list-tile-action>
						<v-list-tile-content>
							<v-list-tile-title>{{
								$t("modules.tours")
							}}</v-list-tile-title>
						</v-list-tile-content>
					</v-list-tile>
					<v-list-group
						v-if="
							$myStore.state.user.user_role_id != 2 &&
								$myStore.state.user.user_role_id != 4
						"
						no-action
						v-model="$myStore.state.subMenuFinance"
					>
						<v-icon slot="prependIcon" small
							>fa-hand-holding-usd</v-icon
						>
						<v-icon slot="appendIcon" small>fa-chevron-down</v-icon>
						<template v-slot:activator>
							<v-list-tile>
								<v-list-tile-title>{{
									$t("modules.finance")
								}}</v-list-tile-title>
							</v-list-tile>
						</template>
						<v-list-tile :to="{ path: '/invoices' }">
							<v-list-tile-action>
								<v-icon small>fa-file-invoice-dollar</v-icon>
							</v-list-tile-action>
							<v-list-tile-content>
								<v-list-tile-title>{{
									$t("modules.invoices")
								}}</v-list-tile-title>
							</v-list-tile-content>
						</v-list-tile>
						<v-list-tile :to="{ path: '/payments' }">
							<v-list-tile-action>
								<v-icon small>fa-money-bill-alt</v-icon>
							</v-list-tile-action>
							<v-list-tile-content>
								<v-list-tile-title>{{
									$t("modules.payments")
								}}</v-list-tile-title>
							</v-list-tile-content>
						</v-list-tile>
					</v-list-group>
					<v-list-group
						v-if="
							$myStore.state.user.user_role_id != 2 &&
								$myStore.state.user.user_role_id != 4
						"
						no-action
						v-model="$myStore.state.subMenuReporting"
					>
						<v-icon slot="prependIcon" small
							>fa-funnel-dollar</v-icon
						>
						<v-icon slot="appendIcon" small>fa-chevron-down</v-icon>
						<template v-slot:activator>
							<v-list-tile>
								<v-list-tile-title>{{
									$t("modules.reporting")
								}}</v-list-tile-title>
							</v-list-tile>
						</template>
						<v-list-tile :to="{ path: '/cash-flow-buyers' }">
							<v-list-tile-action>
								<v-icon small>fa-arrow-left</v-icon>
							</v-list-tile-action>
							<v-list-tile-content>
								<v-list-tile-title>{{
									$t("modules.cashFlowBuyers")
								}}</v-list-tile-title>
							</v-list-tile-content>
						</v-list-tile>
						<v-list-tile :to="{ path: '/cash-flow-suppliers' }">
							<v-list-tile-action>
								<v-icon small>fa-arrow-right</v-icon>
							</v-list-tile-action>
							<v-list-tile-content>
								<v-list-tile-title>{{
									$t("modules.cashFlowSuppliers")
								}}</v-list-tile-title>
							</v-list-tile-content>
						</v-list-tile>
						<v-list-tile :to="{ path: '/tour-profit' }">
							<v-list-tile-action>
								<v-icon small>fa-hand-holding-usd</v-icon>
							</v-list-tile-action>
							<v-list-tile-content>
								<v-list-tile-title>{{
									$t("modules.tourProfit")
								}}</v-list-tile-title>
							</v-list-tile-content>
						</v-list-tile>
					</v-list-group>
					<v-list-group
						v-if="
							$myStore.state.user.user_role_id != 2 &&
								$myStore.state.user.user_role_id != 4
						"
						no-action
						v-model="$myStore.state.subMenuLists"
					>
						<v-icon slot="prependIcon" small>fa-list</v-icon>
						<v-icon slot="appendIcon" small>fa-chevron-down</v-icon>
						<template v-slot:activator>
							<v-list-tile>
								<v-list-tile-title>{{
									$t("modules.lists")
								}}</v-list-tile-title>
							</v-list-tile>
						</template>
						<v-list-tile :to="{ path: '/people' }">
							<v-list-tile-action>
								<v-icon small>fa-users</v-icon>
							</v-list-tile-action>
							<v-list-tile-content>
								<v-list-tile-title>{{
									$t("modules.people")
								}}</v-list-tile-title>
							</v-list-tile-content>
						</v-list-tile>
						<v-list-tile :to="{ path: '/companies' }">
							<v-list-tile-action>
								<v-icon small>fa-industry</v-icon>
							</v-list-tile-action>
							<v-list-tile-content>
								<v-list-tile-title>{{
									$t("modules.companies")
								}}</v-list-tile-title>
							</v-list-tile-content>
						</v-list-tile>
						<v-list-tile :to="{ path: '/destinations' }">
							<v-list-tile-action>
								<v-icon small>fa-map-marker-alt</v-icon>
							</v-list-tile-action>
							<v-list-tile-content>
								<v-list-tile-title>{{
									$t("modules.destinations")
								}}</v-list-tile-title>
							</v-list-tile-content>
						</v-list-tile>
						<v-list-tile :to="{ path: '/tour-categories' }">
							<v-list-tile-action>
								<v-icon small>fa-map</v-icon>
							</v-list-tile-action>
							<v-list-tile-content>
								<v-list-tile-title>{{
									$t("modules.tourCategories")
								}}</v-list-tile-title>
							</v-list-tile-content>
						</v-list-tile>
						<v-list-tile :to="{ path: '/supplier-services' }">
							<v-list-tile-action>
								<v-icon small>fa-parachute-box</v-icon>
							</v-list-tile-action>
							<v-list-tile-content>
								<v-list-tile-title>{{
									$t("modules.supplierServices")
								}}</v-list-tile-title>
							</v-list-tile-content>
						</v-list-tile>
						<v-list-tile :to="{ path: '/service-types' }">
							<v-list-tile-action>
								<v-icon small>fa-boxes</v-icon>
							</v-list-tile-action>
							<v-list-tile-content>
								<v-list-tile-title>{{
									$t("modules.supplierServiceTypes")
								}}</v-list-tile-title>
							</v-list-tile-content>
						</v-list-tile>
						<v-list-tile :to="{ path: '/payment-accounts' }">
							<v-list-tile-action>
								<v-icon small>fa-credit-card</v-icon>
							</v-list-tile-action>
							<v-list-tile-content>
								<v-list-tile-title>{{
									$t("modules.paymentAccounts")
								}}</v-list-tile-title>
							</v-list-tile-content>
						</v-list-tile>
					</v-list-group>
					<v-list-group
						no-action
						v-model="$myStore.state.subMenuSettings"
					>
						<v-icon slot="prependIcon" small>fa-cog</v-icon>
						<v-icon slot="appendIcon" small>fa-chevron-down</v-icon>
						<template v-slot:activator>
							<v-list-tile>
								<v-list-tile-title>{{
									$t("modules.settings")
								}}</v-list-tile-title>
							</v-list-tile>
						</template>
						<v-list-tile
							v-if="$myStore.state.user.user_role_id == 1"
							:to="{ path: '/user-accounts' }"
						>
							<v-list-tile-action>
								<v-icon small>fa-id-card</v-icon>
							</v-list-tile-action>
							<v-list-tile-content>
								<v-list-tile-title>{{
									$t("modules.userAccounts")
								}}</v-list-tile-title>
							</v-list-tile-content>
						</v-list-tile>
						<v-list-tile :to="{ path: '/profile' }">
							<v-list-tile-action>
								<v-icon small>fa-user-tie</v-icon>
							</v-list-tile-action>
							<v-list-tile-content>
								<v-list-tile-title>{{
									$t("modules.profile")
								}}</v-list-tile-title>
							</v-list-tile-content>
						</v-list-tile>
					</v-list-group>
				</v-list>
				<v-img
					height="50px"
					class="mt-3"
					:contain="true"
					:src="publicPath + 'menu_logo.png'"
				/>
			</v-navigation-drawer>
			<v-toolbar app clipped-left fixed>
				<v-toolbar-side-icon
					@click.stop="drawer = !drawer"
				></v-toolbar-side-icon>
				<v-breadcrumbs
					:items="$myStore.state.breadcrumbs"
					divider=">"
				></v-breadcrumbs>
				<v-spacer></v-spacer>
				<v-tooltip bottom v-if="$myStore.state.user.user_role_id != 2">
					<v-btn @click="addPerson" icon slot="activator">
						<v-icon small>fa-user</v-icon>
					</v-btn>
					<span>{{ $t("tooltips.addPerson") }}</span>
				</v-tooltip>
				<v-tooltip bottom v-if="$myStore.state.user.user_role_id != 2">
					<v-btn @click="addCompany" icon slot="activator">
						<v-icon small>fa-industry</v-icon>
					</v-btn>
					<span>{{ $t("tooltips.addCompany") }}</span>
				</v-tooltip>
				<v-tooltip bottom>
					<v-btn @click="logoutClick" icon slot="activator">
						<v-icon>fa-sign-out-alt</v-icon>
					</v-btn>
					<span>{{ $t("tooltips.logout") }}</span>
				</v-tooltip>
			</v-toolbar>
		</template>
		<v-content v-if="initialLoadCompleted">
			<transition name="fade">
				<router-view :key="$route.fullPath"></router-view>
			</transition>
		</v-content>
	</v-app>
</template>

<script>
import InputField from "./components/trinkets/InputField";
import Dropdown from "./components/trinkets/Dropdown";
import DatePicker from "./components/trinkets/DatePicker";
import PersonModal from "./components/modals/PersonModal";
import CompanyModal from "./components/modals/CompanyModal";

export default {
	name: "App",
	components: { DatePicker, InputField, Dropdown, PersonModal, CompanyModal },
	data() {
		return {
			publicPath: process.env.BASE_URL,
			drawer: null,
			alertModal: {
				show: false,
				text: ""
			},
			verifyModal: {
				show: false,
				text: "",
				result: result => {
					this.verifyModal.show = false;
					this.verifyModal.reaction(result);
				},
				reaction: () => {}
			},
			promptModal: {
				show: false,
				text: "",
				value: "",
				result: result => {
					this.promptModal.show = false;
					if (result !== false) {
						this.promptModal.reaction(this.promptModal.value);
					} else {
						this.promptModal.reaction(false);
					}
				},
				reaction: () => {}
			},
			dateModal: {
				title: "",
				show: false,
				text: "",
				error: "",
				value: null,
				result: result => {
					if (this.dateModal.value != null || result === false) {
						this.dateModal.show = false;
						if (result !== false) {
							this.dateModal.reaction(this.dateModal.value);
						} else {
							this.dateModal.reaction(false);
						}
					}
				},
				reaction: () => {}
			},
			dropdownModal: {
				show: false,
				text: "",
				value: "",
				endpoint: null,
				result: result => {
					this.dropdownModal.show = false;
					if (result !== false) {
						this.dropdownModal.reaction(this.dropdownModal.value);
					} else {
						this.dropdownModal.reaction(false);
					}
				},
				reaction: () => {}
			},
			htmlModal: {
				show: false,
				text: ""
			},
			notification: {
				show: false,
				text: ""
			},
			initialLoadCompleted: false,
			fab: false,
			breadcrumbs: [],
			personModalShow: false,
			companyModalShow: false
		};
	},
	computed: {},
	methods: {
		addPerson() {
			this.personModalShow = true;
		},
		personModalCallback() {
			this.personModalShow = false;
		},
		addCompany() {
			this.companyModalShow = true;
		},
		companyModalCallback() {
			this.companyModalShow = false;
		},
		logoutClick() {
			let vm = this;
			this.$verify(this.$t("alerts.logoutQuestion"), result => {
				if (result) {
					vm.$APICall("post", "logout", {}, (data, success) => {
						if (success) {
							vm.$myStore.commit("setUser", null);
							vm.$myStore.commit("setLoggedIn", false);
							vm.$router.push("/login");
						}
					});
				}
			});
		},
		profileClick() {
			this.$router.push("/profile");
		},
		logoClick() {
			this.$router.push("/dashboard");
		}
	},
	mounted() {
		let vm = this;
		this.$modalBus.$on("ALERT", message => {
			vm.alertModal.text = message;
			vm.alertModal.show = true;
		});
		this.$modalBus.$on("VERIFY", data => {
			vm.verifyModal.text = data.message;
			vm.verifyModal.reaction = data.response;
			vm.verifyModal.show = true;
		});
		this.$modalBus.$on("PROMPT", data => {
			vm.promptModal.text = data.message;
			vm.promptModal.value = data.initial;
			vm.promptModal.reaction = data.response;
			vm.promptModal.show = true;
		});
		this.$modalBus.$on("DATE", data => {
			vm.dateModal.text = data.message;
			vm.dateModal.title = data.title;
			vm.dateModal.value = data.initial;
			vm.dateModal.reaction = data.response;
			vm.dateModal.show = true;
		});
		this.$modalBus.$on("DROPDOWN", data => {
			vm.dropdownModal.text = data.message;
			vm.dropdownModal.value = data.initial;
			vm.dropdownModal.reaction = data.response;
			vm.dropdownModal.endpoint = null;
			vm.$nextTick(() => {
				vm.dropdownModal.endpoint = data.endpoint;
			});
			vm.dropdownModal.show = true;
		});
		this.$modalBus.$on("NOTIFY", message => {
			vm.notification.text = message;
			vm.notification.show = true;
		});
		this.$modalBus.$on("ALERT_HTML", message => {
			vm.htmlModal.text = message;
			vm.htmlModal.show = true;
		});

		this.$APICall("get", "session", {}, (data, success) => {
			if (success) {
				vm.$myStore.commit("setUser", data);
				vm.$myStore.commit("setLoggedIn", true);
				let baseRoutes = ["login", null];
				if (baseRoutes.indexOf(vm.$router.currentRoute.name) !== -1) {
					vm.$router.push("dashboard");
				}
				if (data.version != vm.$getCookie("malik_version")) {
					vm.$setCookie("malik_version", data.version);
					window.location.reload(true);
				}
			} else {
				vm.$myStore.commit("setUser", null);
				vm.$myStore.commit("setLoggedIn", false);
				let outsideRoutes = ["reset-password"];
				if (outsideRoutes.indexOf(vm.$router.currentRoute.name) == -1) {
					vm.$router.replace("/login");
				}
			}
			vm.initialLoadCompleted = true;
		});
	}
};
</script>

<style scoped>
.notification {
	z-index: 999999;
}

.loader {
	position: fixed;
	left: 0px;
	top: 0px;
	z-index: 999;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.3);
	font-size: 100px;
	text-align: center;
	padding-top: 100px;
}

.fade-enter {
	opacity: 0;
}

.fade-enter-active {
	transition: opacity 1s;
}

.fade-to {
	opacity: 1;
}

>>> .cursor-pointer {
	cursor: pointer;
}

>>> .bottom-buttons-outer {
	position: fixed;
	bottom: 0px;
	left: 0px;
	width: 100%;
	height: 50px;
	z-index: 9999999999;
	background-color: #efefef;
	text-align: center;
	-webkit-box-shadow: 0px -1px 5px -1px rgba(163, 163, 163, 1);
	-moz-box-shadow: 0px -1px 5px -1px rgba(163, 163, 163, 1);
	box-shadow: 0px -1px 5px -1px rgba(163, 163, 163, 1);
}

>>> .v-navigation-drawer {
	background-color: #1e2933;
}

>>> .background-transparent {
	background: transparent !important;
}

>>> .v-btn {
	box-shadow: none !important;
	border-radius: 8px !important;
}

>>> .module-title {
	font-weight: bold;
	font-size: 20px;
	color: #757575;
	border-bottom: 1px solid #949494;
}

.header-logo {
	max-height: 60px;
}

/deep/ .dialog-html .v-card__text {
	text-align: justify;
	padding-left: 60px;
	padding-top: 60px;
	padding-right: 60px;
	color: #707070 !important;
}

>>> .main-menu .v-list__tile {
	padding: 0px !important;
	padding-left: 10px !important;
}

>>> .main-menu .v-list__tile__action {
	width: 20px !important;
	min-width: 20px !important;
	margin-right: 5px !important;
}

>>> .main-menu .v-list__group__header__prepend-icon {
	padding: 0px !important;
	padding-left: 10px !important;
	width: 20px !important;
	min-width: 20px !important;
	margin-right: 5px !important;
}

>>> .v-list__group__items .v-list__tile {
	padding-left: 30px !important;
}

>>> textarea {
	scrollbar-color: #6ec276 #e2e2e2;
	scrollbar-width: thin;
}

>>> textarea::-webkit-scrollbar {
	width: 7px;
}

>>> textarea::-webkit-scrollbar-track {
	background-color: #e2e2e2;
}

>>> textarea::-webkit-scrollbar-thumb {
	background-color: #6ec276;
}

>>> .no-pa .ma-2 {
	margin: 0px !important;
}
</style>
